import { Component, effect, inject, signal } from '@angular/core';
import { EditorStatus } from '@components/documents-matter-editor/documents-matter-editor.component';
import { SelectedMatterDocumentsDispatch } from '@state/global/documents/selected-matter-documents.dispatch';
import { SnackbarService } from 'src/app/shared/services/ui/snackbar.service';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

export interface DocumentDialogComponentData {
	documentId: string;
	showConverter: boolean;
	showStateSelector?: boolean;
	title: string;
}

@Component({
	selector: 'app-document-dialog',
	templateUrl: './document-dialog.component.html',
	standalone: false,
})
export class DocumentDialogComponent {
	editorStatus: EditorStatus;

	selectedMatterDispatch = inject(SelectedMatterDocumentsDispatch);
	snackbarService = inject(SnackbarService);
	drawerService = inject(DrawerService);
	drawerData = signal<DocumentDialogComponentData>(inject(DRAWER_DATA));

	constructor() {
		effect(() => {
			this.selectedMatterDispatch.SelectedDocuments([
				this.drawerData().documentId,
			]);
		});
	}

	cancelModal(): void {
		this.drawerService.closeDrawer();
	}

	statusChange(currentStatus: EditorStatus): void {
		this.editorStatus = currentStatus;
		if (this.editorStatus === EditorStatus.FAILED) {
			this.snackbarService.openSnackBar({
				text: 'Unable to save document.',
				type: 'error',
			});
		}
	}
}
